module.exports = __webpack_public_path__ + "img/popup-game-sucai.19bf9c2b.png";